import type { ComponentProps } from 'react';
import { OwcMenu } from '@one/react';

export type PocMenuProps = ComponentProps<typeof OwcMenu>;

export const PocMenu: React.FC<PocMenuProps> = (props) => <OwcMenu {...props} />;
